function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Afspraak-contract",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "real-estate-deal-shake-building",
  transform: "translate(4.000000, 3.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("line", {
  x1: 28.0762727,
  y1: 29.2137273,
  x2: 19.9796364,
  y2: 30.8333636,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8636364,21.6873636 L17.0432727,23.2590909 C15.814887,23.741276 14.424329,23.1739019 13.8838967,21.9700053 C13.3434644,20.7661088 13.8436254,19.3499859 15.0202727,18.7525455 L18.8375455,16.898 C19.6772948,16.4789899 20.6522449,16.4231188 21.5343636,16.7434545 L28.5028182,19.4109091",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.40909091,30.9600909 L8.29136364,30.9600909 L13.0915455,34.6104545 C13.5932166,35.1751719 14.4511399,35.2433693 15.0357273,34.765 L22.2390909,28.9772727 C22.8306188,28.4922761 22.927324,27.6239871 22.457,27.0207273 L18.496,22.6579091",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7034545,18.9580909 L14.1872727,18.5330909 C13.3452565,17.9125239 12.2423619,17.7710822 11.271,18.1590909 L5.40909091,20.6580909",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.258090909,33.0217273 L3.349,33.0217273 C3.89563795,33.0217273 4.41986448,32.8044706 4.80625092,32.4177943 C5.19263737,32.031118 5.40950099,31.5067287 5.40909149,30.9600909 L5.40909149,20.6580909 C5.40950099,20.1114531 5.19263737,19.5870638 4.80625092,19.2003875 C4.41986448,18.8137112 3.89563795,18.5964545 3.349,18.5964545 L0.258090909,18.5964545",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.2272727,33.0217273 L30.1363636,33.0217273 C29.5897257,33.0217273 29.0654992,32.8044706 28.6791127,32.4177943 C28.2927263,32.031118 28.0758626,31.5067287 28.0762721,30.9600909 L28.0762721,20.6580909 C28.0758626,20.1114531 28.2927263,19.5870638 28.6791127,19.2003875 C29.0654992,18.8137112 29.5897257,18.5964545 30.1363636,18.5964545 L33.2272727,18.5964545",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.99190909,14.2181818 L3.99190909,1.46818182 C3.99308147,1.08747623 4.18088559,0.731551472 4.49448743,0.515699664 C4.80808927,0.299847856 5.20761023,0.251517402 5.56363636,0.386363636 L18.3136364,6.98545455 C18.7641616,7.1553536 19.0630002,7.58577954 19.0647273,8.06727273 L19.0647273,13.0590909",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7.46918182,
  y1: 7.26518182,
  x2: 3.99190909,
  y2: 7.26518182,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.78736364,
  y1: 11.9015455,
  x2: 3.99190909,
  y2: 11.9015455,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.2646364,
  y1: 4.37209091,
  x2: 13.2646364,
  y2: 0.310636364,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0600909,9.58181818 L28.3328182,9.58181818 C29.6131146,9.58181818 30.651,10.6197035 30.651,11.9 L30.651,13.0590909",
  id: "Path",
  stroke: "#425CD4"
})));
function SvgAfspraakcontract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Afspraak contract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfspraakcontract);
export default __webpack_public_path__ + "static/media/Afspraak contract.b0ea7de18a14a22b6206120b768d1db9.svg";
export { ForwardRef as ReactComponent };